import { render, staticRenderFns } from "./component-qr-code.vue?vue&type=template&id=4861f962&scoped=true&"
import script from "./component-qr-code.vue?vue&type=script&lang=js&"
export * from "./component-qr-code.vue?vue&type=script&lang=js&"
import style0 from "./component-qr-code.vue?vue&type=style&index=0&id=4861f962&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861f962",
  null
  
)

export default component.exports